import script from "./DialogDiversionWater.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogDiversionWater.vue?vue&type=script&setup=true&lang=ts"

import "./DialogDiversionWater.vue?vue&type=style&index=0&id=5dadf780&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dadf780"]])

export default __exports__